import EfCardsAppA from '@elem/ui/ef-cards-app-a';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function TheComp() {
    const { t } = useLang('hat');
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725589828752/service_01.png',
            title: t('L_text1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725589828883/service_02.png',
            title: t('L_text2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725589829190/service_03.png',
            title: t('L_text3'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfTitle>{t('L_title')}</EfTitle>
            <EfCardsAppA list={items} />
            <EfSpec className="spec-x" />
        </div>
    );
}
